// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3pHfj","notes":"Notes_notes__2NKE4"};